export enum FilterOption {
    Cases = 'cases',
    Claims = 'claims',
    Users = 'users',
    ServiceProviders = 'service providers',
    Clients = 'clients',
    Payments = 'payments',
    PaymentExports = 'payment exports',
    PaymentImports = 'payment imports',
    Notes = 'notes',
    CaseHistory = 'case history',
    Calls = 'calls'
}
